module.exports = __webpack_public_path__ + "05d0c430e71d5e2c6f6b2553c49e6066.pdf";